import React from 'react';
import { KLARNA_BUTTON_IMG } from '../../../config/constants/images';
import { KLARNA_BUTTON_IMG_TEXT } from '../../../config/text/text';

const KlarnaButton = () => {
  return (
    <>
      <img
        alt={KLARNA_BUTTON_IMG_TEXT}
        className="klarna"
        src={KLARNA_BUTTON_IMG}
      />
      <span className="sr-only">Klarna</span>
      <style jsx>{`
        .klarna {
          width: 80%;
          padding: 5%;
        }
      `}</style>
    </>
  );
};

export default KlarnaButton;
